import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ib-arrow-left",
  "use": "icon-ib-arrow-left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ib-arrow-left\">\r\n    <path d=\"M712.832 883.498667a42.666667 42.666667 0 0 1-60.330667 0l-341.333333-341.333334a42.666667 42.666667 0 0 1 0-60.330666l341.333333-341.333334a42.666667 42.666667 0 0 1 60.330667 60.330667L401.664 512 712.832 823.168a42.666667 42.666667 0 0 1 0 60.330667z\" p-id=\"6648\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol